var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-contact-form" },
    [
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.contact_information.company_name_label"
            ),
            info: _vm.$t.__(
              "CompanyInformation.contact_information.company_name_help"
            ),
            orientation: "horizontal",
            required: true,
            error: _vm.errors.companyName
          }
        },
        [
          _c("CompassInput", {
            attrs: { error: !!_vm.errors.companyName },
            on: {
              focus: function($event) {
                _vm.errors.companyName = ""
              },
              blur: _vm.checkCompanyName
            },
            model: {
              value: _vm.companyName,
              callback: function($$v) {
                _vm.companyName = $$v
              },
              expression: "companyName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.contact_information.email_label"
            ),
            orientation: "horizontal",
            required: true,
            error: _vm.errors.email
          }
        },
        [
          _c("CompassInput", {
            attrs: { type: "email", error: !!_vm.errors.email },
            on: { blur: _vm.checkEmail },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.contact_information.phone_label"
            ),
            orientation: "horizontal",
            error: _vm.errors.phone
              ? _vm.$t.__("common.labels.please_enter_a_valid_phone_number")
              : ""
          }
        },
        [
          _c("CompassTelInput", {
            attrs: {
              value: _vm.phone,
              defaultCountry: "fr",
              error: _vm.errors.phone
            },
            on: {
              input: function($event) {
                _vm.errors.phone = false
              },
              blur: function($event) {
                return _vm.handleTelInputBlur($event)
              },
              validate: function(value) {
                return _vm.updatePhoneNumber(value)
              },
              "country-changed": function($event) {
                return _vm.handleCountryChange($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.contact_information.website_label"
            ),
            orientation: "horizontal",
            error: _vm.errors.website
          }
        },
        [
          _c("CompassInput", {
            attrs: { error: !!_vm.errors.website },
            on: { blur: _vm.checkWebsite },
            model: {
              value: _vm.website,
              callback: function($$v) {
                _vm.website = $$v
              },
              expression: "website"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "company-contact-form__save-button",
        attrs: {
          type: "tertiary",
          label: _vm.$t.__(
            "CompanyInformation.contact_information.save_button"
          ),
          disabled: _vm.disableSubmit,
          loading: _vm.isLoading
        },
        on: { click: _vm.handleSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }